import { useTranslation } from 'react-i18next';

// The API returns base fields in French plus suffixed variants,
// e.g. title / titleEn / titleMg.
const FIELD_SUFFIXES = { en: 'En', mg: 'Mg' };

export const localizeField = (item, field, language) => {
    if (!item) return '';
    const suffix = FIELD_SUFFIXES[language];
    // Fall back to the French base field when a translation is missing
    return (suffix && item[field + suffix]) || item[field] || '';
};

// Returns loc(item, field) bound to the currently selected language
export const useLocalized = () => {
    const { i18n } = useTranslation();
    const language = i18n.resolvedLanguage || i18n.language;
    return (item, field) => localizeField(item, field, language);
};
